export default "__VITE_ASSET__B4Sm_YXO__"